import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCertDetail as actionGetCertDetail } from 'Redux/modules/webChat/emc/certification/actions';

const useDigiMcPreview = certId => {
  const dispatch = useDispatch();

  const {
    detailCertification: certDetail,
    status: { getDetail: getDetailLoading },
  } = useSelector(state => state.webChat.emc.certification);

  const getCertDetail = () => dispatch(actionGetCertDetail(certId));

  useEffect(() => {
    getCertDetail();
  }, [certId, dispatch]);

  return { certDetail, getCertDetail, loading: getDetailLoading === 0 };
};

export default useDigiMcPreview;
